"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SzTabContent = exports.SzTab = void 0;
var react_1 = __importDefault(require("react"));
var react_responsive_tabs_1 = __importDefault(require("react-responsive-tabs"));
require("./SzTab.scss");
// IMPORTANT you need to include the default styles
require("react-responsive-tabs/styles.css");
function SzTab(_a) {
    var id = _a.id, className = _a.className, activeKey = _a.activeKey, selectTabHandle = _a.selectTabHandle, children = _a.children;
    function getTabs() {
        var tabsList = [];
        react_1.default.Children.forEach(children, function (element) {
            if (!react_1.default.isValidElement(element)) {
                return;
            }
            var _a = element.props, title = _a.title, eventKey = _a.eventKey;
            tabsList.push({
                title: title,
                getContent: function () { return element; },
                key: eventKey,
                tabClassName: className,
                panelClassName: element.props.className
            });
        });
        return tabsList;
    }
    return (react_1.default.createElement(react_responsive_tabs_1.default, { key: activeKey, uid: id, items: getTabs(), selectedTabKey: activeKey, onChange: function (tab) {
            if (selectTabHandle) {
                selectTabHandle(tab);
            }
        } }));
}
exports.SzTab = SzTab;
function SzTabContent(props) {
    return react_1.default.createElement("div", null, props.children);
}
exports.SzTabContent = SzTabContent;
SzTab.SzTabContent = SzTabContent;
exports.default = SzTab;
